// import { useState } from "react";

function LazyLoadingPhoto(props) {
    // const [loaded, setLoaded] = useState(false)
    return (
        <div width="100%">
            <img
                width="100%" src={`/images/${props.base}-small.jpg`}
                // alt={props.base} style={loaded ? { display: "none" } : {}}
                loading="lazy"
            />
            {/* <img
                width="100%" src={`/images/${props.base}.jpg`}
                alt={props.base} style={loaded ? {} : { display: "none" }} onLoad={() => {
                    setLoaded(true)
                    console.log("Setting loaded to true")
                }}
            /> */}
        </div>
    )
}

export default LazyLoadingPhoto;